import { render, staticRenderFns } from "./TrelloColumnList.vue?vue&type=template&id=2c44b0cc&scoped=true&"
import script from "./TrelloColumnList.vue?vue&type=script&lang=js&"
export * from "./TrelloColumnList.vue?vue&type=script&lang=js&"
import style0 from "./TrelloColumnList.vue?vue&type=style&index=0&id=2c44b0cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44b0cc",
  null
  
)

export default component.exports